module.exports = __webpack_public_path__ + "img/FinalLogo.23b9d854.png";